import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { Item, ItemContent, ItemDescription, ItemTitle } from "@/components/ui/item";
import { SearchDomainForm } from "@/features/domain/search-domain/form";
import { SearchResult } from "@/features/domain/search-domain/result";
import { m } from "@/lib/paraglide/messages.js";

// The name searched is route state (guide, rule 16): a link to "is kilat.id free?" asks it again.
const DomainSearch = z.object({ q: z.string().max(253).optional().catch(undefined) });

// /domains/search: one full name per search, live from the registry, the same as GET
// /v3/availability. Pending and suspended resellers search too (domain-search step 8).
export const Route = createFileRoute("/_authenticated/domains/search")({
  validateSearch: DomainSearch,
  staticData: { crumb: m.portal_nav_domain_search },
  component: DomainSearchPage,
});

function DomainSearchPage() {
  const { q = "" } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <>
      <Item>
        <ItemContent>
          <ItemTitle>{m.portal_nav_domain_search()}</ItemTitle>
          <ItemDescription>{m.domain_search_description()}</ItemDescription>
        </ItemContent>
      </Item>
      <SearchDomainForm key={q} initial={q} onSearch={(name) => navigate({ search: { q: name } })} />
      <SearchResult name={q} />
    </>
  );
}
